// Module
var code = "<img/> ";
// Exports
export default code;